export default __webpack_public_path__ + "static/media/user-placeholder.a6143582.png";